import $ from 'jquery';
import ScrollTrigger from '@terwanerik/scrolltrigger';
// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel/dist/assets/owl.theme.default.css';

window.$ = $;
window.jQuery = $;

// require('owl.carousel');
require('./smoothscroll');
require('./cookieconsent');
require('./faqs');
// require('./popups');

// Third-party widgets: Intercom, Hotjar, Facebook Pixel; see ./vendors.js.
// installVendorStubs() is synchronous and makes no network request -- it only
// defines window.Intercom's queue, so the inline `Intercom('show')` handlers
// in the pricing partials and the pollers below work before the widget lands.
var vendors = require('./vendors');
vendors.installVendorStubs();

// Persist the Google Ads click id on the page the ad actually landed on.
// Visitors rarely land straight on /signup — they arrive on /pricing or a
// comparison page and click through, by which point ?gclid= is gone from the
// URL. Google's own _gcl_aw cookie is only written once ad_storage consent is
// granted, so this first-party copy is what makes attribution survive.
(function captureAdClickId() {
  try {
    var search = window.location.search || '';
    if (!search) return;

    var match = search.match(/[?&](?:gclid|gbraid|wbraid)=([^&#]+)/);
    if (!match) return;

    window.localStorage.setItem('lp_click_id', decodeURIComponent(match[1]));
    window.localStorage.setItem('lp_click_id_at', String(Date.now()));
  } catch (e) {
    // private mode / storage disabled — the URL and cookie paths still apply
  }
})();

// Create a new ScrollTrigger instance with default options
var trigger = new ScrollTrigger();
trigger.add('[data-element-appear]');

var openIntercomChat = function (initialMessage, fallbackUrl) {
  var attempts = 0;

  // The visitor may click before the idle-time load has fired, so make sure
  // the widget is on its way before we start waiting on it.
  vendors.loadIntercomWidget();

  var open = function () {
    // Readiness means "the widget booted", not "window.Intercom exists" --
    // the latter is now always true thanks to the queue stub, which would make
    // the fallbackUrl branch below unreachable and silently swallow the
    // message for anyone who has widget.intercom.io blocked.
    if (vendors.isIntercomReady()) {
      if (initialMessage) {
        window.Intercom('showNewMessage', initialMessage);
      } else {
        window.Intercom('show');
      }

      return;
    }

    attempts += 1;

    if (attempts < 16) {
      setTimeout(open, 300);
      return;
    }

    if (fallbackUrl) {
      window.location.href = fallbackUrl;
    }
  };

  open();
};

window.openChat = function (initialMessage, fallbackUrl) {
  openIntercomChat(initialMessage, fallbackUrl);
};

$(document).on('click', '[data-intercom-message]', function (event) {
  event.preventDefault();
  openIntercomChat(this.getAttribute('data-intercom-message'), this.getAttribute('href'));
});

// The Intercom queue stub is installed at the top of this file, so this call
// queues immediately and replays once the widget loads. It used to reschedule
// itself every second, forever, on any page where the widget never loaded.
window.Intercom('trackEvent', 'visited_page', {
  page: window.location.href
});

// navbar essentials
(function () {
  $('#navbarNav').on('click', 'a', function () {
    $('.navbar-toggle').click();
  });

  $('.navbar-toggler').click(function () {
    var collapsable = $(this.dataset.target);
    collapsable.toggleClass(this.dataset.toggle);
    $(this).attr('aria-expanded', !collapsable.hasClass(this.dataset.toggle));
  });

  // media query to check
  // var phoneMQ = '(max-width: 1000px) and (orientation: portrait)';
  var phoneMQ = '(max-width: 1000px)';
  var isPhoneView = window.matchMedia(phoneMQ).matches;
  if (isPhoneView) {
    $('.nav-item').on('click', function () {
      $(this).siblings().find('.dropdown-content').removeClass('visible')
      $('.dropdown-content', this).toggleClass('visible')
    })

    $('.navbar-toggler-icon-alt').on('click', function () {
      $('.nav-item .dropdown-content').removeClass('visible')
    })

  }

})();

// Header scroll
(function () {
  // $(window).scroll(function() {
  var nav = $('#navbar');
  var navbarHeight = nav.height();
  if (nav.length) {
    navbarHeight = parseFloat(window.getComputedStyle(nav[0]).height);
  }

  // var heroSectionHeight = window.innerHeight - (navbarHeight * 2)
  var heroSectionHeight = navbarHeight;

  var onNavbarScroll = function () {
    if ($(this).scrollTop() > heroSectionHeight) {
      nav.addClass('header-scrolled');
    } else {
      nav.removeClass('header-scrolled');
    }
  };

  window.addEventListener('scroll', onNavbarScroll);
  // run init
  setTimeout(onNavbarScroll, 0);
})();

// Vendor bootstrap.
//
// Intercom loads eagerly on idle: the chat launcher should exist for every
// visitor, not only the ones who happen to move a mouse. Hotjar and the
// Facebook pixel stay gated behind the first interaction and then run in idle
// time -- on touch devices the first tap fires `mouseover`, and initialising
// them inline there put them inside that tap's critical path and hurt INP.

function whenIdle(fn, timeout) {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(fn, { timeout: timeout });
  } else {
    setTimeout(fn, 600);
  }
}

function loadEagerVendors() {
  whenIdle(vendors.loadEagerVendors, 2000);
}

if (document.readyState === 'complete') {
  loadEagerVendors();
} else {
  window.addEventListener('load', loadEagerVendors);
}

var deferredVendorsScheduled = false;
function scheduleDeferredVendors() {
  if (deferredVendorsScheduled) return;
  deferredVendorsScheduled = true;

  // Remove the listeners that were actually registered. The previous version
  // removed a function that was never registered as one, so both listeners
  // stayed attached for the life of the page.
  window.document.removeEventListener('mouseover', scheduleDeferredVendors);
  window.removeEventListener('touchstart', scheduleDeferredVendors);

  whenIdle(vendors.loadDeferredVendors, 2000);
}

window.document.addEventListener('mouseover', scheduleDeferredVendors, { passive: true });
window.addEventListener('touchstart', scheduleDeferredVendors, { passive: true });

// lazy load images

function initLazyImages() {
  var lazyloadImages = [];
  var lazyloadThrottleTimeout;
  document.querySelectorAll(".lazy").forEach(function (img) { lazyloadImages.push(img); });

  function lazyload() {
    if (lazyloadThrottleTimeout) {
      clearTimeout(lazyloadThrottleTimeout);
    }

    lazyloadThrottleTimeout = setTimeout(function () {
      var scrollTop = window.pageYOffset;
      lazyloadImages.forEach(function (img) {
        if (img.offsetTop < (window.innerHeight + scrollTop)) {
          img.src = img.dataset.src;
          img.classList.remove('lazy');

          lazyloadImages.splice(lazyloadImages.indexOf(img), 1);
        }
      });

      if (lazyloadImages.length == 0) {
        document.removeEventListener("scroll", lazyload);
        window.removeEventListener("resize", lazyload);
        window.removeEventListener("orientationChange", lazyload);
      }
    }, 20);
  }

  document.addEventListener("scroll", lazyload);
  window.addEventListener("resize", lazyload);
  window.addEventListener("orientationChange", lazyload);
}

// The bundle is loaded with `async defer`, so on a warm cache it can execute
// after the load event has already fired -- a bare addEventListener('load')
// here never ran, and every .lazy image kept its placeholder for the life of
// the page.
if (document.readyState === 'complete') {
  initLazyImages();
} else {
  window.addEventListener('load', initLazyImages);
}

// pricing widget
(function () {
  var onPeriodSwitchTap = function () {
    // var btn = $(this);
    var activePeriod = $(this).data('period');
    // activePeriod = activePeriod || $(this).data('period');
    const currentURL = window.location.href
    if (activePeriod !== 'y' && currentURL.includes('promotion')) {
      return;
    }

    var switchSelector = '.pricing-period-switch .period-control[data-period=' + activePeriod + ']'
    var btn = $(switchSelector);
    btn.siblings().removeClass('selected');
    btn.addClass('selected');

    $(this).parent().siblings().each((i, e) => {
      var label = $(e)
      if (label.data().period === activePeriod) {
        label.addClass('selected')
      } else {
        label.removeClass('selected')
      }
    })

    // if (activePeriod === 'y') {
    //   $('#pricing-plans .pricing-card').not('[data-no-value]').addClass('at-annual');
    //   $('.pricing-list-row').addClass('at-annual');
    //   $('#pricing-plans .plan-id-wrap').addClass('at-annual');
    //   $('#pricing-plans .pricing-table').addClass('at-annual');
    // } else {
    //   $('#pricing-plans .pricing-card').not('[data-no-value]').removeClass('at-annual');
    //   $('.pricing-list-row').removeClass('at-annual');
    //   $('#pricing-plans .plan-id-wrap').removeClass('at-annual');
    //   $('#pricing-plans .pricing-table').removeClass('at-annual');
    // }
    if (activePeriod === 'y') {
      $('.pricing-card').not('[data-no-value]').addClass('at-annual');
      $('.pricing-list-row').addClass('at-annual');
      $('.plan-id-wrap').addClass('at-annual');
      $('.pricing-table').addClass('at-annual');
    } else {
      $('.pricing-card').not('[data-no-value]').removeClass('at-annual');
      $('.pricing-list-row').removeClass('at-annual');
      $('.plan-id-wrap').removeClass('at-annual');
      $('.pricing-table').removeClass('at-annual');
    }

    btn.parent().attr('data-selected-period', activePeriod);
  };

  window.onPeriodSwitchTap = onPeriodSwitchTap;

  var toggleCompanyPricing = function (showCompanyPlans, forLivePlans) {
    $('.pricing-switch-checkbox[data-entity=company]').prop('checked', showCompanyPlans)

    var parenSelector = !forLivePlans ? '#pricing-plans:not([data-product=livestream_cdn])' : '#pricing-plans[data-product=livestream_cdn]'

    if (showCompanyPlans) {
      $('#pricing-plans[data-product=livestream_cdn]').addClass('at-company');
      $('#pricing-plans .pricing-card').addClass('at-company');
      // $('.pricing-card').addClass('at-company');
      $(parenSelector + ' .plan-id-wrap').addClass('at-company');
      $(parenSelector + ' .pricing-table').addClass('at-company');
      $(parenSelector + ' .pricing-switch-wrap').addClass('at-company');
      $(parenSelector + ' .pricing-actions-wrap').addClass('at-company');
    } else {
      $('#pricing-plans[data-product=livestream_cdn]').removeClass('at-company');
      $('#pricing-plans .pricing-card').removeClass('at-company');
      $(parenSelector + ' .plan-id-wrap').removeClass('at-company');
      $(parenSelector + ' .pricing-table').removeClass('at-company');
      $(parenSelector + ' .pricing-switch-wrap').removeClass('at-company');
      $(parenSelector + ' .pricing-actions-wrap').removeClass('at-company');
    }
  };

  var onPlanEntityChange = function () {
    var activeEntity = $(this).data('entity');
    // make changes to whatevery controls
    var showCompanyPlans = activeEntity === 'company';
    if (this.tagName === 'INPUT') {
      showCompanyPlans = this.checked === true;
      if (!showCompanyPlans) {
        activeEntity = 'user'
      }
    }

    var switchSelector = '.pricing-entity-switch .period-control[data-entity=' + activeEntity + ']'
    var btn = $(switchSelector);
    btn.siblings().removeClass('selected');
    btn.addClass('selected');

    toggleCompanyPricing(showCompanyPlans);
  };

  $('.pricing-switch-wrap label').on('click', onPeriodSwitchTap);
  $('.pricing-period-switch .period-control').on('click', onPeriodSwitchTap);

  $('.pricing-entity-switch .period-control').click(onPlanEntityChange);
  // $('.pricing-entity-switch .period-control').click(onPlanEntityChange);

  $('.pricing-switch-checkbox').change(onPlanEntityChange);


  // live delivert type switch
  $('.live-cat-tabs .live-cat-tab').on('click', function () {
    var el = $(this)
    el.addClass('selected')
    el.siblings().removeClass('selected')

    var showCompanyPlans = el.data('entity') === 'company'
    toggleCompanyPricing(showCompanyPlans, true);
  });

})();
